import * as unzipper from 'unzipper';

class FaroDeckPackage {

    private data: any[];

    constructor(data: any[]) {
        this.data = data;
    }

    async build() {
        const rootFileNode = { id: 'root', name: 'root', children: [] };

        const directory = await unzipper.Open.buffer(Buffer.from(this.data));
        directory.files.forEach(async file => {
            this._addFileEntryToTree(rootFileNode, file);
        });

        rootFileNode.children.sort((a, b) => {
            if (a.name.endsWith('deckspec')) {
                return -1;
            }
            // Move folders to the end of the list
            return a.children.length === 0 && b.children.length > 0 ? -1 : 0;
        });

        return rootFileNode;
    }

    _addFileEntryToTree(parentNode: any, file: any, startIndex = 0) {
        const fileName = file.path;
        if (startIndex >= fileName.length) {
            return;
        }

        let isLeaf = false;

        let endIndex = fileName.indexOf('/', startIndex);
        if (endIndex === -1) {
            endIndex = fileName.length;
            isLeaf = true;
        }

        const nodeName = fileName.substring(startIndex, endIndex);
        if (!nodeName) {
            return;
        }

        if (nodeName !== '.') {
            // Check if this item already exists 
            let node = parentNode.children.find(child => child.name === nodeName);
            if (!node) {
                node = { id: fileName.substring(0, endIndex), name: nodeName, children: [], file: isLeaf ? file : undefined };
                parentNode.children.push(node);
            }

            // Add remaining nodes for file path
            this._addFileEntryToTree(node, file, endIndex + 1);
        } else {
            this._addFileEntryToTree(parentNode, file, endIndex + 1);
        }
    }
}

export default FaroDeckPackage;